(function($){

	window.theme = window.theme || {};

	// GLOBAL
	theme.global = {
		
		vars : {},
		
		init : function(){
			var vars = theme.global.vars;
			vars.breakpoint = 768;
			vars.speed = 250;
			vars.$win = $(window);
			vars.$winW = vars.$win.width();	
			vars.$winH = vars.$win.height();
			vars.$body = $('body');
			vars.isMobile = vars.$winW < vars.breakpoint ? true : false;	
			vars.$menu = $('#mobile-menu');
			vars.$openMenu = $('#mobile-menu-btn');
			vars.$closeMenu = vars.$menu.find('.close');
			vars.$menuBtn = $('#menu-btn');
			vars.$mainMenu = $('#main-menu');
			vars.$mainMenuItem = $('.not-current', '#main-menu');
			vars.$menuImg = $('#menu-image');
      vars.$backButton = $('body > .back-to-collection');
          
			vars.$menuItem = $('#main-menu li a');
			vars.$hoverImage = $('.bg-image');
			
			vars.$menuItem.on('mouseenter', theme.global.showHoverImage);
			vars.$menuItem.on('mouseleave', theme.global.hideHoverImage);          
			
			vars.$openMenu.on('click', theme.global.openMenu);
			vars.$closeMenu.on('click', theme.global.closeMenu);
			vars.$menuBtn.on('click', theme.global.toggleMenu);
			vars.$menuBtn.on({
				mouseenter: function(){
					vars.$menuImg.addClass('hover-show');
					console.log("Triggered BNG ENTER");
                    vars.$backButton.css('z-index', 11);
					vars.$mainMenu.addClass('open');
					
				},
				mouseleave: function(){
					console.log("Triggered LEABE");
                  	vars.$backButton.css('z-index', 13);
					vars.$menuImg.removeClass('hover-show');
					vars.$mainMenu.removeClass('open');					
				}
			});
			
			$('.insta-post').click(function(){
				$me = $(this);
				$me.addClass('show');
				$me.siblings().removeClass('show');
			});
			
			vars.$win.on({
				resize: theme.global.resize
			});
			
			//mailchimp ajax
			$('#mc-embedded-subscribe-form').ajaxChimp({
				callback: function(data){
					 $resp = $('.mc-response');
			     if (data.result !== "success") {
			       return $resp.empty().html(data.msg.replace('0 -', '')).show();
			     } else {
			       return $resp.empty().html(data.msg).show();
			     }			
				}
			});		
			
			theme.global.cartCount();

			$('.search-form').submit(function(e) {
              var val = $(this).find('[type="search"]').val().trim().toLowerCase();
              if(val.indexOf('sizes') > -1 || val.indexOf('sizing') > -1 || val.indexOf('size') > -1 || val.indexOf('size guide') > -1) {
                e.preventDefault();
                e.stopPropagation();
                window.location.href = '/pages/size-guide'
              } else if(val.indexOf('returns') > -1 || val.indexOf('return') > -1 || val.indexOf('return policy') > -1 || val.indexOf('exchanges') > -1 || val.indexOf('exchange') > -1 || val.indexOf('exchange policy') > -1) {
                e.preventDefault();
                e.stopPropagation();
                window.location.href = '/pages/return-policy'
              } else if(val.indexOf('sale') > -1) {
                e.preventDefault();
                e.stopPropagation();
                window.location.href = '/collections/sale'
              }
			});
          
          	$(window).unload(function() {
              if(location.pathname.indexOf("/collections") > -1 && location.pathname.indexOf("/products") == -1) {
                var scrollPosition = $(window).scrollTop();
                localStorage.setItem("collectionScrollPosition", scrollPosition);              
                localStorage.setItem("collection_path", location.pathname);
              }
            });
            if(localStorage.collectionScrollPosition && location.pathname.indexOf("/collections") > -1 && location.pathname == localStorage.getItem("collection_path") ) {
              $(window).scrollTop(localStorage.getItem("collectionScrollPosition"));
              setTimeout(function(){ $(window).scrollTop(localStorage.getItem("collectionScrollPosition")) }, 2000);
            }
          
            $('.back-to-collection, .cart.continue-shopping').click(function() {
              if((document.referrer == "" || document.referrer.indexOf('/products') > -1) && localStorage.getItem("collection_path") == null ) {
              	location.href = "/collections/all"
              } else {
              	window.history.back();
              }
              return false;
            });
		},
      
		showHoverImage : function(){
			var bgImg = $(this).data('img');
			
			if($('.full-bg-image#bg-'+bgImg).length){
				$('.full-bg-image#bg-'+bgImg).show();
			}			
		},

		hideHoverImage : function(){
			var bgImg = $(this).data('img');
			
			if($('.full-bg-image#bg-'+bgImg).length){
				$('.full-bg-image#bg-'+bgImg).hide();
			}			
		},
		
		cartCount : function(){
			$.ajax({
			  method: "GET",
			  url: "/cart.js",
			  dataType: "JSON",
			  success: function(data){
			  	$('#cart-count').text(data.item_count);				  	
			  }			
			});
			
		},		
		
		resize : function(){
			var vars = theme.global.vars;
			vars.$winW = vars.$win.width();	
			vars.$winH = vars.$win.height();			
			vars.isMobile = vars.$winW < vars.breakpoint ? true : false;
		},
				
		toggleMenu : function(){
			var vars = theme.global.vars;
			vars.$mainMenuItem.stop().slideToggle(200);
			vars.$menuImg.toggleClass('show');
			//vars.$body.toggleClass('no-scroll');
			vars.$mainMenu.toggleClass('show');
			console.log('test');
		},
		
		openMenu : function(){
			var vars = theme.global.vars;
			vars.$menu.addClass('show');
		},

		closeMenu : function(){
			var vars = theme.global.vars;
			vars.$menu.removeClass('show');
		}
		
		
	}
	
	theme.init = function(){
		var $body = $('body');
		
		theme.global.init();

		if ($body.hasClass('template-index')) {     
			theme.home.init();
		} else

		if ($body.hasClass('template-product')) {   
			theme.product.init();
		} else
		
		if ($body.hasClass('stockists')) {          
			theme.stockists.init();
		} else
		
		if ($body.hasClass('press')) {              
			theme.press.init();
		} else
		
		if ($body.hasClass('collection-blog')) {    
			theme.collectionBlog.init();
		} else 
		
		if ($body.hasClass('template-cart')) {
  		theme.cart.init();
		} else
		
		if ($body.hasClass('template-collection') || $body.hasClass('template-search')) {
			theme.collection.init();
		} 		
	}
	
	// HOME
	theme.home = {
		
		vars : {},
		
		init: function(){
			var vars = theme.home.vars;
			vars.$menuItem = $('#main-menu li a');
			vars.$hoverImage = $('.bg-image');
			
//			vars.$menuItem.on('mouseenter', theme.home.showHoverImage);
//			vars.$menuItem.on('mouseleave', theme.home.hideHoverImage);
			
		},
		
		showHoverImage : function(){
			var bgImg = $(this).data('img');
			console.log("Triggered  showHoverImage");
			if($('#'+bgImg).length){
				$('#'+bgImg).show();
			}			
		},

		hideHoverImage : function(){
			var bgImg = $(this).data('img');
			console.log("Triggered hideHoverImage");
			if($('#'+bgImg).length){
				$('#'+bgImg).hide();
			}			
		}
		
	}
	
	
	// PRODUCT
	theme.product = {
		
		vars : {},
		
		init: function(){
			var vars = theme.product.vars,
    			$form = $('#AddToCartForm'),
    			globalVars = theme.global.vars;
    			
			vars.$details = $('.inner', '.details');
			vars.$images = $('#images');
			vars.$images.slick({
				arrows: true,
				infinite: true,
				dots: true,
				speed: 200
			});
			
      $form.addClass('disabled');      
      $form.on({
        submit: function(e) {
    			if ( $(this).hasClass("disabled") ) {
            e.preventDefault();
      			$('#cart-response').text('Please select a size');
    			}
        }
      });
      
			
/*
			globalVars.$win.on({
				resize: function(){
					theme.product.resize();				
				}
			});
			theme.product.resize();
*/
			
		},
		
		resize: function(){
			var vars = theme.product.vars,
    			globalVars = theme.global.vars,
    			detailsOffset = vars.$details.offset().top,
    			detailsH = vars.$details.height(),
    			maxHeight = (globalVars.$winH - detailsOffset) - 50;
			
			vars.$details.css('max-height', maxHeight);
		}
	}
	
	
	// PRESS
	theme.press = {
		
		vars : {},
		
		init: function(){
			var vars = theme.press.vars;
			
			$('.fancybox').fancybox({
				padding: 0,
				helpers : {
		      title: {
	          type: 'outside'
		      }
			  },
				margin: [150, 50, 50, 50]			  							  				
			});
			
		}
				
	}


	// COLLECTION
	theme.collection = {
		
		vars : {},
		
		init: function(){
			var vars = theme.collection.vars;

			vars.$filterBtn = $('#filter-by');
			vars.$filters = $('#collection-filters');
			vars.$sortWrap = $('#sort-wrap');			
			vars.$product = $('.product', '#collection');
          	vars.loading = false;
			
			$('body').find('.product').matchHeight({
				byRow: false
			});
			
			vars.$filterBtn.click(function(){
				if(!vars.$filters.hasClass('open') && vars.$sortWrap.find('.selection').hasClass('show')){
					vars.$sortWrap.find('.selection').trigger('click');					
				}
				vars.$filters.toggleClass('open');			
			});

			vars.$sortWrap.on('click', '.selection', function(){
				var $me = $(this);
				if($me.hasClass('show') && $('#collection-filters').hasClass('open') ){
					$('#filter-by').trigger('click');			
				}
			});
			
  		$(window).on({
  			scroll: function() {
    			$.doTimeout( 'scroll', 200, theme.collection.scroll_execute() );
  			}
  		});
			
		},
				
    // INFINITE SCROLL
    scroll_execute: function() {
      var vars = theme.collection.vars;
      var $doc = $(document);
      if($doc.height() - 800 < ($doc.scrollTop() + $(window).height())) {
        console.log('run it');
        //scrollNode = $('#more').last(); 
        $more = $('#more')
        scrollURL = $('#more p a').last().attr("href");
        if($more.length > 0 && !vars.loading) {
          vars.loading = true;
          $.ajax({
            type: 'GET',
            url: scrollURL,
            beforeSend: function() {
              //scrollNode.clone().empty().insertAfter(scrollNode);//.append('<img src=\"//lisamariefernandez.com/cdn/shop/t/67/assets/loading.gif?13636\" />');
              //scrollNode.hide();
            },
            success: function(data) {
              // remove loading feedback
              //scrollNode.next().remove();
              var filteredData = $(data).find(".product");
              filteredData.appendTo( $(".products") );    
              
              var $newMore = $(data).find('#more');
              if($newMore.length){
              	$more.html($newMore.html());
              } else {
              	$('#more').remove();
              }
              
              vars.loading = false;
              
              $('body').find('.product').matchHeight({
                byRow: false
              });
            },
            dataType: "html"
          });
        }
      }
    }  
    // END -- INFINITE SCROLL
	}


	// COLLECTION BLOG
	theme.collectionBlog = {
		
		vars : {},
		
		init: function(){
			var vars = theme.collectionBlog.vars;
			vars.altGridBtn = $('#alt-grid');
			vars.fullGridBtn = $('#full-grid');
			
			$('.fancybox').fancybox({
				padding: 0,
				helpers : {
		      title: {
	          type: 'outside'
		      },
		      overlay: {
  		      locked: true 
		      }
			  },
			  autoSize: true,
				margin: [150, 50, 50, 50],
				beforeShow: function() {        
          var title = $(this.element).attr('title');     
          var content = $(this.element).data("content"); 
          
          this.title = title+"<br/>"+content;
        }
							  				
			});
			
			vars.altGridBtn.click(function(){
				$('#collection-articles').addClass('alt-grid');
				$(this).addClass('active').siblings().removeClass('active');
			});

			vars.fullGridBtn.click(function(){
				$('#collection-articles').removeClass('alt-grid');
				$(this).addClass('active').siblings().removeClass('active');
			});
			
		}
	}


	// STOCKISTS
	theme.stockists = {
		
		vars : {},
		
		init: function(){
			var vars = theme.stockists.vars;
			vars.$title = $('.region-title', '#region-titles');
			vars.$region = $('.region', '#regions');

			vars.$title.on('click', theme.stockists.updateRegion);
		},
		
		updateRegion : function(){
			var vars = theme.stockists.vars,
			$me = $(this)
			color = $me.data('color'),
			region = $me.data('region');
			
			console.log(color, region);
			
			vars.$title.css('background', 'none');
			$me.css('background', color);
			
			
			vars.$region.removeClass('show');
			$('#'+region).addClass('show');
			
		}
				
	}
	
	
	// CART
	theme.cart = {
		
		vars : {},
		
		init : function(){
			var vars = theme.cart.vars;
					vars.$increment = $('.cart__qty--increment');
					
			vars.$increment.click(theme.cart.incrementQty);

  		$('#checkout-confirm').on('click', function() {
    		console.log( 'coucou' );
    		$('form.cart :submit').prop('disabled', false);
  		});			  		
		},
		
		incrementQty: function(){
			var vars = theme.cart.vars,
					$me = $(this),
					$input = $me.siblings('.cart__quantity-selector'),
					value = parseInt( $input.val() );
					
			if($me.hasClass('plus')){
				var newValue = value + 1;
				$input.val(newValue).trigger('change');
			} else {
				var newValue = (value - 1) < 1 ? 1 : value - 1;
				$input.val( newValue ).trigger('change');				
			}
		}
		
	}	
		

	$(theme.init);

})(jQuery);